import React from 'react'
import PropTypes from 'prop-types'

import {
  Container,
  LogoContainer,
  Logo,
  Wrapper,
  InvertedBorder,
} from './style'

const CertifiedPurchaseTag = ({
  shouldRender,
  size,
  theme,
  invertedBorder,
  ...rest
}) => {
  return shouldRender ? (
    <Container
      size={size}
      theme={theme}
      invertedBorder={invertedBorder}
      {...rest}
    >
      <Wrapper>
        <LogoContainer>
          <Logo theme={theme} />
        </LogoContainer>
      </Wrapper>
      {invertedBorder && <InvertedBorder />}
    </Container>
  ) : null
}

CertifiedPurchaseTag.defaultProps = {
  size: 'small',
  theme: 'dark',
  invertedBorder: false,
  shouldRender: false,
}

CertifiedPurchaseTag.propTypes = {
  size: PropTypes.string,
  theme: PropTypes.string,
  invertedBorder: PropTypes.bool,
  shouldRender: PropTypes.bool,
}

export default CertifiedPurchaseTag
